$(() => {
    initializeCarouselHeroBlocks();
});

function initializeCarouselHeroBlocks() {
    $(".carousel-hero").each(function () {
        new CarouselHero(this);
    });
}

class CarouselHero {

    el: JQuery<HTMLElement>;
    carouselItem: JQuery<HTMLElement>;

    constructor(carouselContainerElement: HTMLElement) {
        this.el = $(carouselContainerElement);
        this.carouselItem = this.el.find(('.carousel-hero-item'));
        this.carouselItem.each(function() {
            const opacitySettings = this.dataset.opacity;
            const colorSettingsObject: {FontColor: string, BackgroundColor: string} = JSON.parse(this.dataset.backgroundColor);
            if (colorSettingsObject !== null) {
                if (colorSettingsObject.BackgroundColor !== null) {
                    $(this).css("background-color", colorSettingsObject.BackgroundColor);
                }
                if (colorSettingsObject.FontColor !== null) {
                    $(this).css("color", colorSettingsObject.FontColor);
                }
            }
            if (opacitySettings) {
                $(this).find('.overlay').css("opacity", opacitySettings);
            }
        });
    }
}
